export default "__VITE_ASSET__BExMBgz5__"